export const payment = {
  field: {
    date: 'Date',
    amount: 'Amount',
    system: 'Payment System',
    status: 'Status',
    type: 'Payment type'
  },

  update_message:
    'The page is updating and will appear later. Current rates can be requested from the support department.',

  status: {
    new: 'New',
    success: 'Success',
    failed: 'Failed',
    failed_mc: 'Failed',
    frozen: 'Frozen'
  },
  titles: {
    operation_history: 'Operation history',
    top_up: 'Top up',
    methods: 'Payment methods'
  },
  errors: {
    email: 'Some emails were not added'
  },

  payment_system: {
    yoomoney: 'ЮMoney',
    pay_pal: 'PayPal',
    webmoney: 'WebMoney',
    capitalist: 'Capitalist',
    bank_card: 'Bank Card',
    internal: 'Internal',
    zorra: 'Zorra'
  },

  payment_type: {
    a_number_subscription_fee: 'Monthly charge for using the number {number}',
    a_number_connection_cost: 'Charge for number connection {number}',
    referral_reward: 'Replenishment according to the referral program',
    pbx: 'Monthly charge for using the PBX package {package_name}',
    sms_number_verification: 'SMS verification',
    voice_number_verification: 'Verification by audio code',
    phone_number_verification: 'Verification by the last digits of the number',
    call_number_verification: 'Incoming call verification',
    balance_refill: 'Balance refill',
    common: '',
    a_number: 'Monthly charge for using the number',
    mailing_sender: 'Write-offs for using the sender',
    hlr: 'HLR'
  }
};
